/* Discovery interactions only. Existing commerce pixels remain responsible for purchases. */
(() => {
  if (window.spqrJourneyInstalled) return;
  window.spqrJourneyInstalled = true;
  const config = document.querySelector('script[data-spqr-journey-config]');
  const allowed = new Set(['guide_link', 'guide_open', 'material_comparison']);
  function record(el) {
    const action = el.dataset.spqrJourney;
    const subject = el.dataset.spqrSubject || '';
    if (!allowed.has(action) || !/^[a-z0-9-]{1,80}$/.test(subject)) return;
    const payload = {action, subject, revision: 'new-customer-discovery-1'};
    // Local event supports integration and QA; no storage or network request.
    document.dispatchEvent(new CustomEvent('spqr:journey', {detail: payload}));
    const shop = window.Shopify;
    if (config?.dataset.enabled !== 'true' || shop?.designMode || shop?.theme?.role !== 'main') return;
    if (shop.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
    try {
      const result = shop.analytics?.publish?.('spqr:discovery_interaction', payload);
      if (result?.catch) result.catch(() => {});
    } catch (_) { /* Analytics must never interrupt shopping. */ }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[data-spqr-journey]');
    if (link) record(link);
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('details[data-spqr-journey]') && event.target.open) record(event.target);
  }, true);
  function openLinkedGuide() {
    if (location.hash !== '#SelectionGuide') return;
    const guide = document.querySelector('#SelectionGuide details');
    if (guide) guide.open = true;
  }
  window.addEventListener('hashchange', openLinkedGuide);
  openLinkedGuide();
})();

/* Consent UI only. Commerce events continue through the installed Shopify app pixels. */
(() => {
  const panel = document.querySelector('[data-spqr-privacy]');
  if (!panel?.querySelector || window.spqrPrivacyInstalled) return;
  window.spqrPrivacyInstalled = true;
  const settings = document.querySelector('[data-spqr-privacy-settings]');
  const reopen = settings?.querySelector('[data-spqr-consent-reopen]');
  const options = panel.querySelector('#SpqrPrivacyOptions');
  const toggle = panel.querySelector('[data-spqr-consent="preferences"]');
  const status = panel.querySelector('[data-spqr-consent-status]');
  const purposes = ['preferences', 'analytics', 'marketing'];
  let privacy, pending = false, manuallyOpened = false;
  // Let an installed manager own consent, including one that loads after this script.
  function otherManager() {
    return Boolean(window.Cookiebot || window.OneTrust || window.privacyBanner ||
      document.querySelector('#shopify-pc__banner, #shopify-pc__prefs, #onetrust-consent-sdk, #CybotCookiebotDialog, .cc-window, script[src*="privacy-banner/storefront-banner"], script[src*="booster_eu_cookie"]'));
  }
  function consent() { return privacy.currentVisitorConsent(); }
  function hasChoice(current) { return purposes.every(key => current[key] === 'yes' || current[key] === 'no'); }
  function syncOptions() {
    const current = consent();
    purposes.forEach(key => { panel.querySelector(`input[name="${key}"]`).checked = current[key] === 'yes'; });
  }
  function refresh() {
    if (!privacy || otherManager()) { panel.hidden = true; if (settings) settings.hidden = true; return; }
    if (settings) settings.hidden = false;
    if (!manuallyOpened) panel.hidden = !(privacy.shouldShowBanner() === true && !hasChoice(consent()));
  }
  function finish(message) {
    pending = false;
    panel.querySelectorAll('button').forEach(button => { button.disabled = false; });
    status.textContent = message || ''; status.hidden = !message;
  }
  function save(choice) {
    if (pending || !privacy || otherManager()) return;
    pending = true;
    panel.querySelectorAll('button').forEach(button => { button.disabled = true; });
    status.hidden = true;
    // Preserve an existing data-sharing opt-out; accepting cookies must never undo it.
    if (choice.marketing === false || navigator.globalPrivacyControl === true) choice.sale_of_data = false;
    const timeout = window.setTimeout(() => finish('Your choice could not be saved. Please try again.'), 8000);
    try {
      privacy.setTrackingConsent(choice, result => {
        window.clearTimeout(timeout);
        if (result?.error || !purposes.every(key => consent()[key] === (choice[key] ? 'yes' : 'no'))) {
          finish('Your choice could not be saved. Please try again.'); return;
        }
        const focused = panel.contains(document.activeElement);
        finish(); manuallyOpened = false; panel.hidden = true;
        options.hidden = true; toggle.setAttribute('aria-expanded', 'false');
        if (focused && reopen && !settings.hidden) reopen.focus({preventScroll: true});
      });
    } catch (_) {
      window.clearTimeout(timeout); finish('Your choice could not be saved. Please try again.');
    }
  }
  panel.addEventListener('click', event => {
    const action = event.target.closest('[data-spqr-consent]')?.dataset.spqrConsent;
    if (!action || pending) return;
    if (action === 'preferences') {
      if (options.hidden) syncOptions();
      options.hidden = !options.hidden;
      toggle.setAttribute('aria-expanded', String(!options.hidden));
      return;
    }
    if (!['accept', 'decline', 'save'].includes(action)) return;
    const choice = {};
    purposes.forEach(key => { choice[key] = action === 'save' ? panel.querySelector(`input[name="${key}"]`).checked : action === 'accept'; });
    save(choice);
  });
  reopen?.addEventListener('click', () => {
    if (!privacy || otherManager()) return;
    manuallyOpened = true; syncOptions(); panel.hidden = false; options.hidden = false;
    toggle.setAttribute('aria-expanded', 'true'); panel.querySelector('h2').focus({preventScroll: true});
  });
  function ready() {
    const api = window.Shopify?.customerPrivacy;
    if (!api?.currentVisitorConsent || !api?.shouldShowBanner || !api?.setTrackingConsent) return;
    privacy = api;
    try { refresh(); } catch (_) { panel.hidden = true; if (settings) settings.hidden = true; return; }
    document.addEventListener('visitorConsentCollected', () => {
      if (!pending) manuallyOpened = false;
      try { refresh(); } catch (_) { panel.hidden = true; }
    });
    const observer = new MutationObserver(() => { if (otherManager()) { panel.hidden = true; if (settings) settings.hidden = true; observer.disconnect(); } });
    observer.observe(document.body, {childList: true, subtree: true});
  }
  if (window.Shopify?.customerPrivacy) ready();
  else if (window.Shopify?.loadFeatures) {
    try { window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) ready(); }); } catch (_) { /* No consent change if the API is unavailable. */ }
  }
})();
